import { ITEMS_CATEGORIES, ITEMS_RARITY, ITEMS_RESOURCE, ItemTemplate } from "../constants";

export default {
    type: "flags",
    listData: [{
        "key": "name",
        "label": "Name",
    }, {
        "key": "resource",
        "label": "Resource",
    }, {
        "key": "price",
        "label": "Price",
    }, {
        "key": "rarity",
        "label": "Rarity",
    }, {
        "key": "group",
        "label": "Group",
    }],
    template: [{
        "key": "name",
        "label": "Name",
        "type": "input",
    }, {
        "key": "game_id",
        "label": "Game Id",
        "type": "input",
        "format": "integer"
    }, {
        "key": "price",
        "label": "Price",
        "type": "input",
        "format": "integer"
    }, {
        "key": "resource",
        "label": "Resource",
        "type": "select",
        "values": ITEMS_RESOURCE
    }, {
        "key": "group",
        "label": "Category",
        "type": "select",
        "values": ITEMS_CATEGORIES
    }, {
        "key": "rarity",
        "label": "Rarity",
        "type": "select",
        "values": ITEMS_RARITY
    }]
} as ItemTemplate;
